module.exports = __webpack_public_path__ + "img/steam.3c4f2aab.svg";